import { Building2 } from "lucide-react";
import {
  EntitySwitcher,
  type EntitySwitcherProps,
  type SwitcherEntity,
} from "./entity-switcher";

const PROJECT_CONFIG = {
  icon: Building2,
  bg: "bg-blue-600",
  label: "Projects",
  searchPlaceholder: "Search projects...",
  emptyLabel: "No projects found.",
  fallbackName: "Project",
  requireShiftKey: false,
  separateChildren: true,
} as const;

export type ProjectSwitcherProps = Omit<
  EntitySwitcherProps,
  "entities" | "activeId"
> & {
  projects: SwitcherEntity[];
  activeProjectId: string;
};

export function ProjectSwitcher({
  projects,
  activeProjectId,
  ...rest
}: ProjectSwitcherProps) {
  return (
    <EntitySwitcher
      activeId={activeProjectId}
      config={PROJECT_CONFIG}
      entities={projects}
      {...rest}
    />
  );
}
